import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import Idel2MeasureScore from '../idel2-summary/Idel2MeasureScore';
import { localizeDate } from '../../../common/localization';
import { useAppContext } from '../../../common/contexts/AppContext';
import {
    ASSESSMENT_TYPE,
    MEASURE_SCORE_DISPLAY_NAMES,
    IDEL2_MEASURES,
    AVAILABLE_SKILL_NAMES_BY_MEASURE_NAMES,
} from '../../../constants/assessments';
import { GRADE } from '../../../constants/enrollment';
import { resultType, studentType } from '../../../constants/prop-types';

const Idel2PMResultRow = ({ result, currentMeasure, student, classId }) => {
    const { formsMap } = useAppContext();
    const {
        period,
        measure,
        clientId,
        formUid,
        clientModDate,
        formGrade,
        formNumber,
        createDate,
    } = result;
    const isCLPL = measure === 'CLPL';
    const rawScore = isCLPL ? result.rawScore : result.measureScores[currentMeasure].rawScore;
    const skillName = isCLPL
        ? AVAILABLE_SKILL_NAMES_BY_MEASURE_NAMES[measure]
        : result.measureScores[currentMeasure].skillName;
    const { id } = student;

    const formLabelText = isCLPL
        ? `G${formGrade === GRADE.KG ? formGrade : formGrade.slice(1)}, F${formNumber}`
        : get(formsMap, `[${formUid}].label`, '');

    const windowDate = isCLPL ? createDate : clientModDate;

    const isFormAvailable = isCLPL ? false : formsMap.hasOwnProperty(formUid);

    return (
        <div key={`${clientId}-${skillName}-row`} className='dashboard-measure-info'>
            <div className='dashboard-skill'>
                <div className='dashboard-measure-container'>
                    <span className='dashboard-skill-name'>{skillName}</span>
                    <span className='dashboard-measure-name'>
                        {MEASURE_SCORE_DISPLAY_NAMES[currentMeasure]}
                    </span>
                </div>
            </div>
            <div className='dashboard-form'>{formLabelText}</div>
            <div className='dashboard-window-dates'>{localizeDate(windowDate)}</div>
            <Idel2MeasureScore
                score={rawScore}
                studentId={id}
                measure={measure}
                period={period}
                classId={classId}
                resultId={clientId}
                fromPage={ASSESSMENT_TYPE.PM}
                isFormAvailable={isFormAvailable}
                key={`${clientId}-${skillName}-score`}
            />
        </div>
    );
};

Idel2PMResultRow.propTypes = {
    student: studentType.isRequired,
    classId: PropTypes.string.isRequired,
    result: resultType.isRequired,
    currentMeasure: PropTypes.oneOf(IDEL2_MEASURES).isRequired,
};

export default Idel2PMResultRow;
